import { type FC, lazy, Suspense } from 'react';
import { BarChartLine } from 'react-bootstrap-icons';

import type { OccupancyView } from '../../../../modules/interfaces/dashboard';
import { WidgetCard } from './WidgetCard';

/** Keeps recharts out of the main bundle — see OccupancyChart. */
const OccupancyChart = lazy(() => import('./OccupancyChart'));

export interface OccupancyTrendCardProps {
  occupancy?: OccupancyView;
  loading: boolean;
}

const CHART_HEIGHT = 260;

export const OccupancyTrendCard: FC<OccupancyTrendCardProps> = ({
  occupancy,
  loading,
}) => (
  <WidgetCard
    title="Occupancy Rate"
    subtitle={occupancy ? `Monthly, ${occupancy.year}` : 'Monthly'}
    loading={loading}
    isEmpty={!loading && !occupancy?.hasData}
    emptyIcon={<BarChartLine size={28} />}
    emptyMessage={
      occupancy
        ? `No occupancy data for ${occupancy.year} yet.`
        : 'No occupancy data available yet.'
    }
    placeholderHeight={CHART_HEIGHT}
  >
    {occupancy && (
      <Suspense
        fallback={
          <div
            className="dashboard-card__placeholder"
            style={{ height: CHART_HEIGHT }}
            aria-hidden="true"
          />
        }
      >
        <OccupancyChart occupancy={occupancy} height={CHART_HEIGHT} />
      </Suspense>
    )}
  </WidgetCard>
);
